import script from "./MonitoringView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonitoringView.vue?vue&type=script&setup=true&lang=ts"

import "./MonitoringView.vue?vue&type=style&index=0&id=e58a1f34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e58a1f34"]])

export default __exports__